import { WalletType } from '@api';

export const formatWalletTypeCase = (type?: string): WalletType | undefined => {
  const map: Record<string, WalletType> = {
    WALLETCONNECT: 'WalletConnect',
    WALLETCONNECT2: 'WalletConnect2',
    PHANTOM: 'Phantom',
    METAMASK: 'EVM',
    EVM: 'EVM',
  };

  return map[type?.toUpperCase() as string];
};
